document.addEventListener("DOMContentLoaded", () => {
    // MVスライダー
    function setupInfiniteSlider(wrapper) {
        if (!wrapper) return; // 要素がなければ終了
        if (wrapper.dataset.marqueeInitialized) return;
        wrapper.dataset.marqueeInitialized = 'true';

        const slides = Array.from(wrapper.children);
        if (slides.length === 0) return;

        let totalWidth = 0;

        slides.forEach(slide => {
            const slideWidth = slide.getBoundingClientRect().width;
            const style = window.getComputedStyle(slide);
            const marginRight = parseFloat(style.marginRight) || 0;
            const marginLeft = parseFloat(style.marginLeft) || 0;
            totalWidth += slideWidth + marginRight + marginLeft;
        });

        slides.forEach(slide => {
            const clone = slide.cloneNode(true);
            wrapper.appendChild(clone);
        });

        if (totalWidth > 0) {
            wrapper.style.setProperty('--total-width', `-${totalWidth}px`);
        }
    }

    // ローディング時のアニメーション
    const targets = document.querySelectorAll('.load-anime');
    targets.forEach(target => {
        target.classList.add('load-anime--start');
    });

    const mainSwiperWrapper = document.querySelector(".chouchou-day-mv__swiper-wrapper");
    setupInfiniteSlider(mainSwiperWrapper);
    if(mainSwiperWrapper) {
      mainSwiperWrapper.classList.add('marquee--to-left');
    }

    // スクロールアニメーション
    function setupScrollAnimations() {
        const targets = document.querySelectorAll('.fade-in-on-scroll');

        if (targets.length === 0) return;

        const options = {
            root: null,
            rootMargin: '0px',
            threshold: 0.1
        };

        const callback = (entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-visible');
                    observer.unobserve(entry.target);
                }
            });
        };

        const observer = new IntersectionObserver(callback, options);
        targets.forEach(target => {
            observer.observe(target);
        });
    }

    setupScrollAnimations();

    // タブ切り替え
    function setupProductTabs() {
        const tabs = document.querySelectorAll('.chouchou-day-hot__category-list-item');

        // 変更点：ターゲットを個々の商品(li)から、商品のリスト全体(ul)に変更
        const productLists = document.querySelectorAll('.chouchou-day-products--hot .chouchou-day-products__list--hot');

        if (tabs.length === 0 || productLists.length === 0) {
            return; // 要素がなければ何もしない
        }

        tabs.forEach(tab => {
            tab.addEventListener('click', (e) => {
                e.preventDefault(); // リンクのデフォルト動作（あれば）を停止

                // (1) クリックされたタブの data-category を取得
                const targetCategory = tab.dataset.category;

                // (2) すべてのタブからアクティブクラスを削除し、クリックされたものだけに追加
                tabs.forEach(t => t.classList.remove('chouchou-day-hot__category-list-item--active'));
                tab.classList.add('chouchou-day-hot__category-list-item--active');

                // (3) すべての商品リスト(ul)をチェック
                productLists.forEach(list => {
                    // リストの data-category がクリックされたタブの category と一致するか
                    if (list.dataset.category === targetCategory) {
                        // 一致したら表示 (display: none; を解除)
                        list.style.display = ''; 
                    } else {
                        // 一致しなかったら非表示
                        list.style.display = 'none';
                    }
                });
            });
        });
    }

    setupProductTabs();

    // アコーディオン
    function setupAccordion() {
        const accordionItems = document.querySelectorAll('.chouchou-day-benefits__list-item');

        if (accordionItems.length === 0) return;

        accordionItems.forEach(item => {
            const btn = item.querySelector('.chouchou-day-benefits__list-item-content-btn');
            const content = item.querySelector('.chouchou-day-benefits__list-item-content');

            if (!btn || !content) {
                return;
            }

            // (1) ボタンにクリックイベントを設定
            btn.addEventListener('click', (e) => {
                e.preventDefault(); // <a>タグの画面遷移をキャンセル

                // (2) 親の <li> に .is-open クラスを付け外し（トグル）
                item.classList.toggle('is-open');

                // (3) ボタンのテキストを切り替え
                if (item.classList.contains('is-open')) {
                    // 開いた時
                    btn.textContent = '閉じる';
                } else {
                    // 閉じた時
                    btn.textContent = '詳しくみる';
                }
            });
        });
    }

    // アコーディオン機能を実行
    setupAccordion();

    // 画像複製
    const originalItems = document.querySelectorAll(".layerd-img");
    originalItems.forEach(item => {
        // 2重実行を防止
        if (item.dataset.cloned) return;
        item.dataset.cloned = 'true';

        const clone1 = item.cloneNode(true);
        clone1.classList.add("layerd-img-02");
        const clone2 = item.cloneNode(true);
        clone2.classList.add("layerd-img-03");
        item.after(clone2);
        item.after(clone1);
    });


// タイムセールのタイマー
const timerElement = document.querySelector(".chouchou-day-timesale__timer");
if (timerElement) {

    // セール開催日を定義 (毎月4日、14日、24日)
    const SALE_DAYS = [4, 14, 24];
    const ONE_DAY_MS = 1000 * 60 * 60 * 24; // 24時間のミリ秒

    /**
     * 現在時刻から見て、最も近い未来のセール期間 (開始時刻と終了時刻) を計算します。
     * セールは該当日の 00:00:00 に開始し、23:59:59.999 に終了すると仮定します。
     * @returns {{startTime: number, endTime: number}} セールの開始・終了時刻 (ミリ秒)
     */
    function getNextSaleWindow() {
        const now = new Date();
        const currentYear = now.getFullYear();
        const currentMonth = now.getMonth();

        // 今月と来月のセール日をチェックして、最も近い未来のセールを探す
        // i=0: 今月, i=1: 来月
        for (let i = 0; i < 2; i++) {
            const checkMonth = currentMonth + i;

            // 月をまたぐ場合の年と月の調整
            const targetYear = checkMonth > 11 ? currentYear + 1 : currentYear;
            const targetMonth = checkMonth % 12;
            
            for (const day of SALE_DAYS) {
                // セール開始時間: 00:00:00
                const startTime = new Date(targetYear, targetMonth, day, 0, 0, 0, 0);
                // セール終了時間: 23:59:59.999
                const endTime = new Date(targetYear, targetMonth, day, 23, 59, 59, 999);

                // 現在時刻より終了時刻が未来の場合、それが次の有効なセール期間
                if (endTime.getTime() > now.getTime()) {
                    return {
                        startTime: startTime.getTime(),
                        endTime: endTime.getTime()
                    };
                }
            }
        }
        
        // 念のためのフォールバック (通常は到達しない)
        return { startTime: 0, endTime: 0 };
    }


    // 初期セール期間を設定
    let saleWindow = getNextSaleWindow();
    let SALE_START_TIME = saleWindow.startTime;
    let SALE_END_TIME = saleWindow.endTime;
    
    // data-startTime/endTime の代わりに動的な値を使用するため、オリジナルのチェックは不要になります。
    // if (!startTimeString || !endTimeString) ...
    // if (isNaN(SALE_START_TIME) || isNaN(SALE_END_TIME)) ...


    // 1秒ごとに関数を実行
    const interval = setInterval(() => {
        const now = new Date().getTime();

        // 💡 セールが終了していたら、次のセール期間を計算し直す
        if (now >= SALE_END_TIME) {
            saleWindow = getNextSaleWindow();
            SALE_START_TIME = saleWindow.startTime;
            SALE_END_TIME = saleWindow.endTime;
        }

        const distanceToStart = SALE_START_TIME - now;
        const distanceToEnd = SALE_END_TIME - now;

        // --- (A) セール前 (次回開催までのカウントダウン) ---
        if (distanceToStart > 0) {
            
            // 24時間以上ある場合は「〇〇日」表示
            if (distanceToStart > ONE_DAY_MS) {
                const days = Math.floor(distanceToStart / ONE_DAY_MS);
                
                // ユーザーの要望「次の開催日までの時間を表示したい」に合わせて文言を調整
                timerElement.innerHTML = `<small class="chouchou-day-timesale__timer-head">次回開催まで</small><span>${days}</span>日`;
            }
            // 24時間未満の場合は「HH:MM:SS」表示
            else {
                const hours = Math.floor((distanceToStart % ONE_DAY_MS) / (1000 * 60 * 60));
                const minutes = Math.floor((distanceToStart % (1000 * 60 * 60)) / (1000 * 60));
                const seconds = Math.floor((distanceToStart % (1000 * 60)) / 1000);
                timerElement.innerHTML =
                    '<small class="chouchou-day-timesale__timer-head">タイムセール<br>開始まで</small>' +
                    `<span>${String(hours).padStart(2, '0')}</span>:` +
                    `<span>${String(minutes).padStart(2, '0')}</span>:` +
                    `<span>${String(seconds).padStart(2, '0')}</span>`;
            }
        }
        // --- (B) セール中 (終了までのカウントダウン) ---
        else if (distanceToEnd > 0) {
            const days = Math.floor(distanceToEnd / ONE_DAY_MS);
            const hours = Math.floor((distanceToEnd % ONE_DAY_MS) / (1000 * 60 * 60));
            const minutes = Math.floor((distanceToEnd % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((distanceToEnd % (1000 * 60)) / 1000);

            let html = '<small class="chouchou-day-timesale__timer-head">タイムセール<br>終了まで</small>';
            if (days > 0) {
                html += `<span>${days}</span>日 `;
            }
            
            html += `<span>${String(hours).padStart(2, '0')}</span>:` +
                    `<span>${String(minutes).padStart(2, '0')}</span>:` +
                    `<span>${String(seconds).padStart(2, '0')}</span>`;
            timerElement.innerHTML = html;
        }
        // --- (C) セール終了直後 ---
        else {
            // セールが終了した直後、次のセール期間が再設定されるまでのごく短い時間。
            // 処理を継続することで、すぐに「次回開催まで」のカウントダウンに切り替わります。
            // 元のコードにあった clearInterval(interval); は削除し、タイマーが継続するようにします。
            
            // 念のため、表示を更新
            timerElement.innerHTML = '<small class="chouchou-day-timesale__timer-head">タイムセール</small>開催準備中';
        }

    }, 1000);
}

    // タイムセールのスライダー
    const timesaleLists = document.querySelectorAll(".chouchou-day-timesale-slider__list");
    timesaleLists.forEach((list, index) => {
        setupInfiniteSlider(list);
        if (index % 2 === 0) { 
            list.classList.add('chouchou-day-timesale-slider__list--right');
        } else { 
            list.classList.add('chouchou-day-timesale-slider__list--left');
        }
    });

    // スムーススクロールとヘッダーオフセット、特定アコーディオンの制御
    function setupSmoothScroll() {
        // (1) ナビゲーション内のアンカーリンクをすべて取得
        const links = document.querySelectorAll('a[href^="#"]');
        
        // (2) 追従ヘッダー要素を取得
        const siteHeader = document.querySelector('#SiteHeader'); // メインヘッダー
        const navHeader = document.querySelector('.chouchou-day-nav'); // 今回のナビ

        // リンクかナビヘッダーがなければ終了
        if (links.length === 0 || !navHeader) {
            return;
        }

        links.forEach(link => {
            link.addEventListener('click', function(event) {
                // (3) デフォルトの瞬時ジャンプをキャンセル
                event.preventDefault(); 

                const hash = this.getAttribute('href');
                const targetElement = document.querySelector(hash);
                if (!targetElement) return; // 飛び先がなければ何もしない

                // (4) 【特別処理】 #chouchou-day-subsc へのリンクの場合
                if (hash === '#chouchou-day-subsc') {
                    let accordionItem = null;
                    
                    // IDが <li class="...benefits__list-item"> に直接ついているかチェック
                    if (targetElement.classList.contains('chouchou-day-benefits__list-item')) {
                        accordionItem = targetElement;
                    } 
                    // IDが親セクションについている場合
                    else { 
                        accordionItem = targetElement.querySelector('.chouchou-day-benefits__list-item');
                    }

                    // アコーディオンが閉じていたら、ボタンをクリックして開く
                    if (accordionItem && !accordionItem.classList.contains('is-open')) {
                        const btn = accordionItem.querySelector('.chouchou-day-benefits__list-item-content-btn');
                        if (btn) {
                            btn.click(); // setupAccordion のロジックを発火
                        }
                    }
                }

                // (5) 【ヘッダーオフセット計算】
                let totalOffset = 0;
                const navStyle = window.getComputedStyle(navHeader);
                
                // SCSSの定義 `top: 46px` (スマホ) か `top: 0` (PC) かを動的に判定
                if (parseFloat(navStyle.top) > 0) { 
                    // スマホ (top: 46px) の場合: #SiteHeader + .chouchou-day-nav
                    if (siteHeader) {
                        totalOffset = siteHeader.offsetHeight;
                    }
                    totalOffset += navHeader.offsetHeight;
                } else { 
                    // PC (top: 0) の場合: .chouchou-day-nav のみ
                    totalOffset = navHeader.offsetHeight;
                }
                
                // (6) 【スムーススクロール実行】
                const targetPosition = targetElement.getBoundingClientRect().top;
                const offsetPosition = window.scrollY + targetPosition - totalOffset;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            });
        });
    }

    setupSmoothScroll();
});

/**
 * Instagram Graph APIからメディアデータを取得し、HTMLを構築して
 * '.chouchou-day-sns__content' 要素に挿入する関数。
 */
async function fetchAndDisplayInstagramMedia() {
    // 新しい: あなたが作ったCloudflare Workerへ
    // Cloudflare WorkerのURLは、Worker画面の右上に表示されています (例: https://instagram-proxy.xxx.workers.dev)
    const API_URL = 'https://instagram-proxy.h-nakatsuka-chouchou.workers.dev';

    const targetDiv = document.querySelector('.chouchou-day-sns__content');
    if (!targetDiv) return;
    targetDiv.classList.add('is-loading');

    try {
        const response = await fetch(API_URL, {
            method: 'GET'
        });

        if (!response.ok) {
            throw new Error(`HTTP Error! Status: ${response.status}`);
        }

        const json = await response.json();

        processInstagramData(json);

    } catch (error) {
        console.error('Instagramメディアの取得中にエラーが発生しました:', error);
    } finally {
        // 🌟 修正ポイント 2: 処理完了時に必ずクラスを削除
        targetDiv.classList.remove('is-loading');
    }
}

// ---

/**
 * HTML属性に埋め込む値をエスケープする関数。
 */
function escapeAttr(str) {
    return String(str ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}

/**
 * http(s) のURLだけを許可し、エスケープして返す関数。それ以外は空文字。
 */
function safeUrl(url) {
    return /^https?:\/\//i.test(url || '') ? escapeAttr(url) : '';
}

/**
 * 取得したJSONデータを処理し、ULリストを作成してDIV要素に挿入する関数。
 * 最初のリストから順番に3つずつ詰めていきます。
 * @param {Object} json - Instagram Graph APIから返されたJSONデータ
 */
function processInstagramData(json) {
    const insta = json.data;
    const targetDiv = document.querySelector('.chouchou-day-sns__content');

    if (!targetDiv || !insta || insta.length === 0) return;
    
    // 既存のコンテンツをクリア
    targetDiv.innerHTML = ''; 

    // 最大リスト数と1リストあたりのアイテム数
    const numberOfLists = 4;
    const itemsPerList = 3; // 1つのULリストに詰めるアイテム数

    let mediaIndex = 0;
    let finalHTML = '';

    // 4つの <ul> リストを生成しようと試みる
    for (let i = 0; i < numberOfLists; i++) {
        let ulContent = '';
        let itemsAddedToCurrentList = 0; // 現在のリストに何個アイテムを追加したか

        // 1つの <ul> に対応するメディアアイテムを最大 itemsPerList 個（3個）まで構築
        while (itemsAddedToCurrentList < itemsPerList && mediaIndex < insta.length) {
            
            const item = insta[mediaIndex];
            const media_type = item.media_type;
            let content_html = '';

            const link_start = `<a href="${safeUrl(item.permalink)}" class="chouchou-day-sns__list-item-link" target="_blank" rel="noopener noreferrer">`;
            const link_end = `</a>`;

            // --- コンテンツ構築ロジック ---
            // ※ リール除外ロジックは削除済み
            if (media_type === "IMAGE") {
                content_html = `<img src="${safeUrl(item.media_url)}" alt="Instagram Photo">`;

            } else if (media_type === "CAROUSEL_ALBUM") {
                const firstChild = item.children && item.children.data[0];
                if (firstChild) {
                    const media_url = firstChild.media_url;
                    const alt_text = firstChild.media_type === "VIDEO" ? "Instagram Video" : "Instagram Photo";

                    if (firstChild.media_type === "VIDEO") {
                        content_html = `<video src="${safeUrl(media_url)}" alt="${alt_text}" autoplay muted loop playsinline></video>`;
                    } else if (firstChild.media_type === "IMAGE") {
                        content_html = `<img src="${safeUrl(media_url)}" alt="${alt_text}">`;
                    }
                }

            } else if (media_type === "VIDEO") {
                content_html = `<video src="${safeUrl(item.media_url)}" alt="Instagram Video" autoplay muted loop playsinline></video>`;
            }
            
            // 有効なコンテンツが構築された場合のみ、リストに加える
            if (content_html) {
                ulContent += `
                    <li class="chouchou-day-sns__list-item fade-in-on-scroll is-visible">
                        ${link_start}
                            ${content_html}
                        ${link_end}
                    </li>
                `;
                // リストに追加した回数だけカウントアップ
                itemsAddedToCurrentList++;
            }
            
            // APIデータ配列のインデックスは常に進める
            mediaIndex++;
        }
        
        // <li>コンテンツが1つでもあれば、<ul>タグを生成
        if (ulContent) {
            finalHTML += `<ul class="chouchou-day-sns__list">${ulContent}</ul>`;
        } else {
            // 有効なデータが尽きた場合は、UL生成ループを終了
            break;
        }
        
        // 全てのアイテムを使い切ったら、UL生成ループも終了
        if (mediaIndex >= insta.length) break;
    }

    // 構築した全てのULリストをDIV要素に追加
    targetDiv.insertAdjacentHTML('beforeend', finalHTML);
}

// ページロード時に関数を実行
document.addEventListener('DOMContentLoaded', fetchAndDisplayInstagramMedia);

/* ==============================================
   Mechanic連動エントリーロジック (エラー修正版)
============================================== */
(() => {
  // ▼▼▼ Mechanicで発行したWebhook URLをここに貼ってください ▼▼▼
  const MECHANIC_WEBHOOK_URL = "https://webhooks.mechanic.dev/f01ea177-8860-41d7-95c9-9d06ae878c35";

  const TARGET_BTN_SELECTOR = '.chouchou-day__entry-btn';
  const COMPLETED_CLASS = 'is-completed';
  const DISABLED_CLASS = 'is-disabled';
  
  // 設定
  const TARGET_DAYS = [4, 14, 24];
  const PRE_ENTRY_DAYS_BEFORE = 4; // 「何日前」から事前エントリー可能にするか
  
  const TAG_ENTRY = "CHOUCHOUの日ポイント_エントリー";
  const TAG_PRE_ENTRY = "CHOUCHOUの日_事前エントリー";

  // 日本時間(JST)のDateオブジェクトを取得
  const getJSTDate = () => new Date(new Date().toLocaleString("en-US", {timeZone: "Asia/Tokyo"}));

  // ■ 当日かどうか
  const isTargetDay = () => TARGET_DAYS.includes(getJSTDate().getDate());

  // ■ 次の開催日を取得（Dateオブジェクト）
  const getNextTargetDate = () => {
    const now = getJSTDate();
    const currentDay = now.getDate();
    let targetYear = now.getFullYear();
    let targetMonth = now.getMonth(); // 0-11

    // 今日より後の開催日を探す
    let targetDay = TARGET_DAYS.find(d => d > currentDay);

    // 今月中にない場合、来月の最初の開催日
    if (!targetDay) {
      targetDay = TARGET_DAYS[0];
      targetMonth++; // 来月へ
      if (targetMonth > 11) { // 12月を超えたら翌年1月へ
        targetMonth = 0;
        targetYear++;
      }
    }
    return new Date(targetYear, targetMonth, targetDay);
  };

  // ■ 事前エントリー期間中かどうか判定
  // （次の開催日の [PRE_ENTRY_DAYS_BEFORE]日前 ～ 前日 までなら true）
  const isPreEntryPeriod = () => {
    const now = getJSTDate();
    // 当日は事前期間ではない
    if (isTargetDay()) return false;

    const nextTarget = getNextTargetDate();
    // 開始日 = 開催日 - N日
    const startDate = new Date(nextTarget);
    startDate.setDate(startDate.getDate() - PRE_ENTRY_DAYS_BEFORE);
    
    // 時間を00:00:00にリセットして日付のみで比較
    now.setHours(0,0,0,0);
    startDate.setHours(0,0,0,0);

    return now.getTime() >= startDate.getTime();
  };

  // ■ 完了状態にする
  const markAsCompleted = (btn, text) => {
    btn.dataset.isCompleted = "true";
    btn.textContent = text;
    btn.classList.add(COMPLETED_CLASS);
    btn.removeAttribute('href');
    btn.style.pointerEvents = 'none';
    btn.style.opacity = '0.7';
  };

  // ■ 期間外（待機中）にする
  const markAsDisabled = (btn) => {
    if (btn.dataset.isDisabled) return;
    
    // 次回の事前エントリー開始日を表示してあげる
    const nextTarget = getNextTargetDate();
    const startDate = new Date(nextTarget);
    startDate.setDate(startDate.getDate() - PRE_ENTRY_DAYS_BEFORE);
    const dateText = `${startDate.getMonth()+1}/${startDate.getDate()}`;

    btn.dataset.isDisabled = "true";
    btn.textContent = `${dateText}から事前エントリー開始`;
    btn.classList.add(DISABLED_CLASS);
    btn.removeAttribute('href');
    btn.style.pointerEvents = 'none';
    btn.style.opacity = '0.5';
    btn.style.cursor = 'not-allowed';
    btn.style.backgroundColor = '#ccc';
  };

  const initCustomEntryButtons = () => {
    const btns = document.querySelectorAll(TARGET_BTN_SELECTOR);
    if (btns.length === 0) return;

    const customerId = window.shopifyCurrentCustomerId;
    const customerTags = window.customerTags || [];
    const isLoggedIn = (customerId !== null && customerId !== undefined);
    
    const _isTargetDay = isTargetDay();
    const _isPreEntryPeriod = isPreEntryPeriod();
    const hasEntryTag = customerTags.includes(TAG_ENTRY);
    const hasPreEntryTag = customerTags.includes(TAG_PRE_ENTRY);

    btns.forEach(btn => {
      if (btn.dataset.processed) return;
      btn.dataset.processed = "true";

      // ------------------------------------------------
      // (A) 表示ロジック（優先度順）
      // ------------------------------------------------
      
      // 1. 本エントリー済みなら常に「完了」
      if (isLoggedIn && hasEntryTag) {
        markAsCompleted(btn, 'エントリー済み');
        return;
      }

      // 2. 当日かどうか
      if (_isTargetDay) {
        if (isLoggedIn && hasPreEntryTag) {
          btn.textContent = '今すぐエントリーする'; // 事前済みの人も当日用ボタンへ
        } else {
          btn.textContent = isLoggedIn ? '今すぐエントリーする' : 'まずはログイン';
          if (!isLoggedIn) {
             const currentPath = window.location.pathname;
             btn.href = `/account/login?return_url=${encodeURIComponent(currentPath)}`;
          }
        }
        return;
      }

      // 3. 事前エントリー期間内かどうか
      if (_isPreEntryPeriod) {
        if (isLoggedIn && hasPreEntryTag) {
          markAsCompleted(btn, '事前エントリー済み');
        } else {
          btn.textContent = isLoggedIn ? '事前エントリーする' : 'まずはログイン';
          if (!isLoggedIn) {
             const currentPath = window.location.pathname;
             btn.href = `/account/login?return_url=${encodeURIComponent(currentPath)}`;
          }
        }
        return;
      }

      // 4. それ以外（期間外）
      markAsDisabled(btn);
    });

    // ------------------------------------------------
    // (B) クリック処理（期間外や完了済みのボタンは押せない）
    // ------------------------------------------------
    btns.forEach(btn => {
      // 既にイベント登録済みならスキップ(重複防止)
      if (btn.dataset.hasListener) return;
      btn.dataset.hasListener = "true";

      btn.addEventListener('click', async (e) => {
        // 無効・完了・期間外なら何もしない
        if (btn.dataset.isCompleted || btn.dataset.isDisabled) return;
        
        // 未ログインならログインページへ
        if (!isLoggedIn) return;

        e.preventDefault();
        const originalText = btn.textContent;
        btn.textContent = '送信中...';
        btn.style.pointerEvents = 'none';

        try {
          const res = await fetch(MECHANIC_WEBHOOK_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ customerId: customerId })
          });

          if (!res.ok) throw new Error('Network error');
          
          if (_isTargetDay) {
              alert("エントリー完了！300ポイントを付与しました。");
              markAsCompleted(btn, 'エントリー済み');
          } else {
              alert("事前エントリーが完了しました！\n4のつく日に自動でポイントが付与されます。");
              markAsCompleted(btn, '事前エントリー済み');
          }

        } catch (err) {
          console.error(err);
          alert('エラーが発生しました。時間をおいて再度お試しください。');
          btn.textContent = originalText;
          btn.style.pointerEvents = 'auto';
        }
      });
    });
  };

  document.addEventListener('DOMContentLoaded', initCustomEntryButtons);
})();